import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-business-icon',
    templateUrl: './business-icon.component.html',
    styleUrls: ['./business-icon.component.scss']
})
export class BusinessIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 22;
        this.width = 24;
    }
}
